import { render } from "./VTextEditor.vue?vue&type=template&id=1088747b"
import script from "./VTextEditor.vue?vue&type=script&lang=js"
export * from "./VTextEditor.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/bookdialysis/bookdialysis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__